export default __webpack_public_path__ + "static/media/gallery_12.52b90f62.jpg";